<template>
  <div>
    <el-dialog v-if="mode===1"
               :title="$t('contactInfo.contInfo')"
               :visible.sync="dialogVisible"
               width="30%"
               center>
      <el-form label-position="right" label-width="100px" :model="info">
        <el-form-item :label="$t('contactInfo.pregTel')">
          <el-input v-model="info.user" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contactInfo.drTel')">
          <el-input v-model="info.doctor" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contactInfo.hospName')">
          <el-input v-model="info.hospital.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('contactInfo.hospTel')">
          <el-input v-model="info.hospital.tel" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('contactInfo.close') }}</el-button>
      </span>
    </el-dialog>
    <el-form label-position="right" label-width="100px" :model="info" v-else-if="mode===0">
      <el-form-item :label="$t('contactInfo.pregTel')">
        <el-input v-model="info.user" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="$t('contactInfo.drTel')">
        <el-input v-model="info.doctor" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="$t('contactInfo.hospName')">
        <el-input v-model="info.hospital.name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item :label="$t('contactInfo.hospTel')">
        <el-input v-model="info.hospital.tel" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ContactInfo',
  props: {
    data: {
      type: Object,
      default: null
    },
    displayMode: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      info: {
        user: '',
        doctor: '',
        hospital: {
          name: '',
          tel: ''
        }
      },
      dialogVisible: false,
      mode: -1
    }
  },
  created: function () {
  },
  mounted () {
    this.mode = this.displayMode
    if (this.mode > -1) {
      this.init(this.data, this.mode)
    }
  },
  methods: {
    init (data, mode) {
      this.mode = mode
      if (data === null) {
        this.info.user = '--'
      } else {
        this.info.user = data.name + ' - ' + data.phone
      }

      if (data === null || data.doctor === null) {
        this.info.doctor = '--'
      } else if (data.doctor.name === null || data.doctor.name.length === 0) {
        this.info.doctor = '--'
      } else {
        let info = data.doctor.name
        if (data.doctor.phone) {
          info += ' - ' + data.doctor.phone
        }
        this.info.doctor = info
      }

      if (data === null || data.hospital === null) {
        this.info.hospital.name = '--'
        this.info.hospital.tel = '--'
      } else if (data.hospital.name === null || data.hospital.name.length === 0) {
        this.info.hospital.name = '--'
        this.info.hospital.tel = '--'
      } else {
        this.info.hospital.name = data.hospital.name
        if (data.hospital.tel !== null && data.hospital.tel.length > 0) {
          this.info.hospital.tel = data.hospital.tel
        }
      }
    },
    close () {
      this.dialogVisible = false
    },
    show (data) {
      this.init(data, 1)
      this.dialogVisible = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
